import React, { useEffect, useState } from 'react';
import * as M from './index.styled';
import { CampaignData } from '@/@types/CampaignData';
import { useNavigate, useParams } from 'react-router-dom';
import { ResData } from '@/@types';
import axiosRequest from '@/api';
import { Spin, message } from 'antd';

//캠페인 등록 시 모바일 미리보기 화면
function MobileView() {
  const [data, setData] = useState<CampaignData>({
    id: null,
    title: '',
    start_date: '',
    end_date: '',
    media: '',
    sub_media: '',
    authentication_method: '',
    campaign_product_id: 0,
    related_url: '',
    related_content: '',
    total_points: 0,
    initial_point: 0,
    points_per_call: 0,
    points_per_participant: 0,
    points_per_wepick: 0,
    campaign_content: '',
    campaign_details: '',
    banner_img: '',
    status: 'a',
    advertiser_id: 0,
    agency_id: 0,
    participation_count: 0,
    participation_count_p: 0,
    participation_count_d: 0,
    participation_count_r: 0,
    sk_approved: false,
    product_name: '',
    is_visible: false,
    goal_count: 0,
    is_test: false,
  });

  const { id } = useParams(); // 캠페인 id 값을 기준으로 화면 로딩
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // 로딩 시작
      try {
        const response = await axiosRequest.requestAxios<ResData<CampaignData>>(
          'get',
          `/campaign/${id}`, // id 별 캠페인 데이터
        );

        if (response.data) {
          setData(response.data);
        } else {
          message.error('캠페인 데이터를 찾을 수 없습니다.');
        }
      } catch (error) {
        console.error('Error fetching campaign data:', error);
        message.error('데이터를 불러오는 중 오류가 발생했습니다.');
      }
      setIsLoading(false); // 로딩 완료
    };

    fetchData();
  }, [id]); // id 값

  const handleContactUs = () => { };

  if (isLoading) {
    return (
      <M.LoadingSpin>
        <Spin tip="Loading" size="large" />
      </M.LoadingSpin>
    );
  }

  return (
    <M.MobileWrapper>
      <M.MobileContainer>
        <M.MobileImgBox>
          {data.banner_img.split(',').length === 0 ? (
            <p></p>
          ) : (
            data.banner_img.split(',').map((url, index) => <img key={index} src={url} alt={`Banner Image ${index}`} />)
          )}
        </M.MobileImgBox>

        <M.MobileContent>
          <M.MobileTitle>{data.campaign_content}</M.MobileTitle>
          <M.MobileContentDetail>{data.campaign_details}</M.MobileContentDetail>
          {data.media === 'action' ? (
            <M.MobilePointButton
              disabled={data.participated}

            >
              참여하고 즉시 포인트 받기
            </M.MobilePointButton>) : (
            <M.MobilePointButton
              disabled={data.participated}
            >
              참여하고 즉시 포인트 받기
            </M.MobilePointButton>)
          }

        </M.MobileContent>
        <M.AdditionaTextBox>
          <M.AdditionaTextItem>
            <M.Star>*</M.Star> 최초 1회만 참여 가능합니다.
          </M.AdditionaTextItem>
          <M.AdditionaTextItem>
            <M.Star>*</M.Star> 이벤트 참여 전 개인정보 동의가 필요합니다.
          </M.AdditionaTextItem>
          <M.AdditionaTextItem>
            <M.Star>*</M.Star> 네이버페이 포인트 적립 시 회원가입이 필요합니다.
          </M.AdditionaTextItem>
          {data.media === 'card' ? (
            <M.AdditionaTextItem>
              <M.Star>*</M.Star> &quot;카드사용알림&quot; 서비스는 각 카드사에서 제공하는 유료 (300원/월) 서비스입니다.
            </M.AdditionaTextItem>
          ) : null}
          {data.media === 'action' ? null : (
            <M.AdditionaTextItem>
              <M.Star>*</M.Star> 다크모드로 화면을 캡쳐할 경우 인식이 어려울 수 있습니다.
            </M.AdditionaTextItem>
          )}
          {data.sub_media === 'car_insurance_join' ? (
            <M.AdditionaTextItem>
              <M.Star>*</M.Star> 본 프로모션의 리워드는 동일한 휴대폰 번호 기준, 최초 가입 차량 1대에 한해 지급됩니다.
            </M.AdditionaTextItem>
          ) : null}
          <M.AdditionaTextItem>
            <M.ContactUsBtn onClick={handleContactUs}>
              <p>지급 문의</p> <span>는 여기를 눌러주세요 {'>'}</span>
            </M.ContactUsBtn>
          </M.AdditionaTextItem>
        </M.AdditionaTextBox>
      </M.MobileContainer>
    </M.MobileWrapper>
  );
}

export default MobileView;
